<template>
    <page>
        <module>
            <div class="order-state flex-between-center">
                <h1>【{{ checkState }}】：{{ orderState }}</h1>
            </div>

            <div class="flex-between">
                <dl class="order-info">
                    <dt>终端订单信息</dt>
                    <dd>
                        <div class="order-info-item flex">
                            <label>终端订单编号：</label>
                            <p>
                                <a @click="navigateTo(`/order_detail/${orderDetail.order_number}`)">{{orderDetail.order_number}}</a>
                                <div class="tag" v-if="orderDetail.is_cloud_stock == 1 && systemConfig.cloud_stock == 'ON'" style="background: #057215">囤货</div>
                                <div class="tag" v-if="orderDetail.order_type!=1" style="background: #4686e0">
                                    {{ orderTypeName[orderDetail.order_type] }}
                                </div>
                                <a @click="clipboard(orderDetail.order_number)" style="color: blue">&nbsp;复制单号</a>
                            </p>
                        </div>
                        <div class="order-info-item flex"
                             v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'">
                            <label>运营模式：</label>
                            <p>{{ operationModeName[orderDetail.operation_mode] }}</p>
                        </div>
                        <div class="order-info-item flex"
                             v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'">
                            <label>商家角色：</label>
                            <p>{{ orderDetail.stationed_auth_name }}</p>
                        </div>
                        <div class="order-info-item flex" v-if="systemConfig.pt_mode == 2">
                            <label>所属商家：</label>
                            <p>{{ orderDetail.stationed_name }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>下单时间：</label>
                            <p>{{ orderDetail.create_date }} <!-- <a>更多</a> --></p>
                        </div>
                        <div class="order-info-item flex">
                            <label>付款状态：</label>
                            <p>{{ paymentState }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>付款方式：</label>
                            <p>{{ orderDetail.payment_type ? orderDetail.payment_type : '--' }}</p>
                        </div>
                        <div class="order-info-item flex" v-if="orderDetail.payment_type=='转账支付'">
                            <label>付款凭证：</label>
                            <p>
                                <c-image :src="orderDetail.pay_voucher_url" size="20" preview></c-image>
                            </p>
                        </div>
                    </dd>
                </dl>
                <dl class="order-info">
                    <dt>代理订单信息</dt>
                    <dd>
                        <div class="order-info-item flex">
                            <label>代理订单编号：</label>
                            <p>
                                {{subOrderDetail.order_number}}
                                <a @click="clipboard(subOrderDetail.order_number)" style="color: blue">&nbsp;复制单号</a>
                            </p>
                        </div>
                        <div class="order-info-item flex">
                            <label>下单时间：</label>
                            <p>{{ subOrderDetail.create_date }} <!-- <a>更多</a> --></p>
                        </div>
                        <div class="order-info-item flex">
                            <label>转单状态：</label>
                              <p v-if="subOrderDetail.state == -1" style="color: red">审核驳回</p>
                              <p v-else-if="subOrderDetail.state == 0" style="color: darkgray">待支付</p>
                              <p v-else-if="subOrderDetail.state == 1" style="color: brown">待审核</p>
                              <p v-else-if="subOrderDetail.state == 2" style="color: green">已审核</p>
                              <p v-else>--</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>转单方式：</label>
                              <p v-if="subOrderDetail.agency_user_id != -2 && subOrderDetail.deal_mode == 1" style="color:green">云仓发货</p>
                              <p v-else-if="subOrderDetail.agency_user_id != -2 && subOrderDetail.deal_mode == 2" style="color:brown">上级发货</p>
                              <p v-else-if="subOrderDetail.agency_user_id != -2 && subOrderDetail.deal_mode == 3" style="color:darkred">自行发货</p>
                              <p v-else-if="subOrderDetail.agency_user_id != -2 && !subOrderDetail.deal_mode" style="color: darkgray">待处理</p>
                              <p v-else>-</p>
                        </div>
                    </dd>
                </dl>

                <dl class="order-info">
                    <dt>下单会员</dt>
                    <dd>
                        <div class="order-info-item flex">
                            <label>头像：</label>
                            <c-image :src="subOrderDetail.order_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        </div>
                        <div class="order-info-item flex">
                            <label>昵称：</label>
                            <p>{{ subOrderDetail.order_nick_name ? subOrderDetail.order_nick_name : '--' }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>手机号：</label>
                            <p>{{ subOrderDetail.order_user_manage_mobilephone }}</p>
                        </div>
                        <div class="order-info-item flex">
                            <label>等级：</label>
                            <p>{{ subOrderDetail.order_level_name }}</p>
                        </div>
                    </dd>
                </dl>

                <dl class="order-info">
                    <dt>接单代理</dt>
                  <dd>
                    <div class="order-info-item flex">
                      <label>头像：</label>
                      <c-image v-if="subOrderDetail.agency_user_id != -2" :src="subOrderDetail.agency_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                      <span v-else>--</span>
                    </div>
                    <div class="order-info-item flex">
                      <label>昵称：</label>
                      <p v-if="subOrderDetail.agency_user_id == -2" style="color: red">{{ subOrderDetail.agency_nick_name ? subOrderDetail.agency_nick_name : '--' }}</p>
                      <p v-else>{{ subOrderDetail.agency_nick_name ? subOrderDetail.agency_nick_name : '--' }}</p>
                    </div>
                    <div class="order-info-item flex">
                      <label>手机号：</label>
                      <p>{{ subOrderDetail.agency_user_manage_mobilephone }}</p>
                    </div>
                    <div class="order-info-item flex">
                      <label>等级：</label>
                      <p>{{ subOrderDetail.agency_level_name }}</p>
                    </div>
                  </dd>
                </dl>

            </div>
        </module>

        <module>
            <div class="order-detail">
                <dt>下单商品</dt>
                <c-table v-model="productList" height="auto" :paging="false" border v-if="orderDetail">
                    <c-table-column
                            label="商品信息"
                            width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                                          :name="data.product_itemnumber + ' - '+data.product_name"
                                          image-size="60"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"
                                          image-size="60"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="规格名"
                            width="110"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_spec }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="商品SKU编码"
                            width="120"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_code ? data.product_sku_code : '--' }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="成交单价"
                    >
                        <template v-slot="{data}">
                            <span v-if="orderDetail.order_type == 2">
                                ￥{{parseFloat(data.product_unit_price||0).toFixed(2)}}
                                + {{data.points}}积分
                            </span>
                            <span v-else>
                               ￥{{parseFloat(data.product_unit_price).toFixed(2)}}
                            </span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="数量"
                            width="80"
                    >
                        <template v-slot="{data}">
                            ×{{ data.product_count }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="商品总额"
                    >
                        <template v-slot="{data}">
                            <span v-if="orderDetail.order_type == 2">
                                ￥{{parseFloat(data.product_money||0).toFixed(2)}}
                                +{{parseFloat(data.points)*parseFloat(data.product_count)}}积分
                            </span>
                            <span v-else>
                               ￥{{parseFloat(data.product_money).toFixed(2)}}
                            </span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="重量小计(克)"
                            width="100"
                    >
                        <template v-slot="{data}">
                            {{ data.product_weight ? data.product_weight : '--' }}
                        </template>
                    </c-table-column>
                </c-table>
                <dt v-if="giftProductList.length > 0">赠品信息</dt>
                <c-table v-if="giftProductList.length > 0" v-model="giftProductList" height="auto" :paging="false"
                         border>
                    <c-table-column
                            label="赠品商品信息"
                            width="300"
                    >
                        <template v-slot="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                                          :name="data.product_itemnumber + ' - '+data.product_name"
                                          image-size="60"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"
                                          image-size="60"></product-info>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="规格名"
                            width="150"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_spec }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="商品SKU编码"
                            width="120"
                    >
                        <template v-slot="{data}">
                            {{ data.product_sku_code ? data.product_sku_code : '--' }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="数量"
                            width="100"
                    >
                        <template v-slot="{data}">
                            ×{{ data.product_count }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="重量小计(克)"
                            width="100"
                    >
                        <template v-slot="{data}">
                            {{ data.product_weight ? data.product_weight : '--' }}
                        </template>
                    </c-table-column>

                </c-table>
                <dt v-if="cusTomList.length > 0">定制信息</dt>
                <c-table v-if="cusTomList.length > 0" v-model="cusTomList" height="auto" :paging="false" border>
                    <c-table-column
                            label="定制项"
                            width="200"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.item_type==1"
                                  style="font-weight:bold;color:chocolate">{{ data.custom_name }}</span>
                            <span v-if="data.item_type!=1">{{ data.custom_name }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制内容"
                            width="260"
                    >
                        <template v-slot="{data}">
                            <span>{{ data.custom_value }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制数量"
                            width="80"
                    >
                        <template v-slot="{data}">
                            ×{{ data.product_count }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制费用单价"
                    >
                        <template v-slot="{data}">
                            {{ parseFloat(data.product_price).toFixed(2) }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制费用小计"
                    >
                        <template v-slot="{data}">
                            {{ parseFloat(data.product_price_money).toFixed(2) }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制费用单价(报价)"
                            width="140"
                    >
                        <template v-slot="{data}">
                            {{ parseFloat(data.product_price_cost).toFixed(2) }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="定制费用小计(报价)"
                            width="140"
                    >
                        <template v-slot="{data}">
                            {{ parseFloat(data.product_price_cost_money).toFixed(2) }}
                        </template>
                    </c-table-column>
                </c-table>
                <dt v-if="reducedList.length > 0">优惠信息</dt>
                <c-table v-if="reducedList.length > 0" v-model="reducedList" height="auto" :paging="false" border>
                    <c-table-column
                            label="优惠类型"
                            width="100"
                    >
                        <template v-slot="{data}">
                            {{ reducedTypeName[data.reduced_type] }}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="优惠金额"
                            width="100"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.reduced_money<=0" style="color:red">￥{{ data.reduced_money }}</span>
                            <span v-else style="color:green">￥ {{ data.reduced_money }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="优惠承担方"
                            width="110"
                    >
                        <template v-slot="{data}">
                            <span>{{ carryTypeName[data.carry_type] }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="备注"
                            width="300"
                    >
                        <template v-slot="{data}">
                      <span>
                         {{ data.remark }}
                      </span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                            width="100"
                    >
                        <template v-slot="{data}">
                            <c-table-button @click="reducedDetail(data.id,data.remark)">优惠明细</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
                <dt v-if="invoiceInfo">开票信息</dt>
                <dl v-if="invoiceInfo" class="invoice-info">
                    <dd class="flex">
                        <div>
                            <div v-if="invoiceInfo.invoice_type == 1" class="invoice-info-item flex">
                                <label>发票类型：</label>
                                <p>普通发票</p>
                            </div>
                            <div v-if="invoiceInfo.invoice_type == 2" class="invoice-info-item flex">
                                <label>发票类型：</label>
                                <p>增值税专用发票</p>
                            </div>
                            <div v-if="invoiceInfo.invoice_type == 3" class="invoice-info-item flex">
                                <label>发票类型：</label>
                                <p>增值税专用发票13%</p>
                            </div>
                            <div class="invoice-info-item flex">
                                <label>纳税人识别号：</label>
                                <p>{{ invoiceInfo.tax_number }}</p>
                            </div>
                            <div class="invoice-info-item flex">
                                <label>收票联系人：</label>
                                <p>{{ invoiceInfo.contact_name || '--' }}<span
                                        v-if="invoiceInfo.contact_phone">（电话：{{ invoiceInfo.contact_phone }}）</span><span
                                        v-if="invoiceInfo.email">（邮箱：{{ invoiceInfo.email }}）</span></p>
                            </div>
                            <div class="invoice-info-item flex">
                                <label>收票地址：</label>
                                <p>{{ invoiceAddress || '--' }}</p>
                            </div>
                        </div>
                        <div class="flex-grow">
                            <div class="invoice-info-item flex">
                                <label>发票抬头：</label>
                                <p>{{ invoiceInfo.invoice_title }}</p>
                            </div>
                            <div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
                                <label>开户行账号：</label>
                                <p>{{ invoiceInfo.bank_account }}（开户行{{ invoiceInfo.bank_name }}）</p>
                            </div>
                            <div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
                                <label>开票地址：</label>
                                <p>{{ invoiceInfo.kp_address || '--' }}</p>
                            </div>
                            <div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
                                <label>开票电话：</label>
                                <p>{{ invoiceInfo.kp_phone || '--' }}</p>
                            </div>
                        </div>
                        <div class="flex-grow">
                            <div class="invoice-info-item flex">
                                <label>开票状态：</label>
                                <p>{{ orderDetail.invoice_state == 2 ? '已开票' : '未开票' }}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2" class="invoice-info-item flex">
                                <label>开票完成时间：</label>
                                <p>{{ orderDetail.invoice_date }}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2" class="invoice-info-item flex">
                                <label>开票实收金额：</label>
                                <p>{{ parseFloat(orderDetail.reality_money).toFixed(2) }}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2" class="invoice-info-item flex">
                                <label>开票凭证：</label>
                                <p>
                                    <a :href="orderDetail.invoice_file"
                                       target="_blank">{{ orderDetail.invoice_file }}</a>
                                </p>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dt v-if="orderDetail.consignor_name || orderDetail.consignor_phone">代发信息</dt>
                <dl v-if="orderDetail.consignor_name || orderDetail.consignor_phone" class="invoice-info">
                    <dt>【代发】发货人信息</dt>
                    <dd class="flex">
                        <div>
                            <div class="invoice-info-item flex">
                                <label>发货人姓名：</label>
                                <p>{{ orderDetail.consignor_name || '--' }}</p>
                            </div>
                            <div class="invoice-info-item flex">
                                <label>发货人电话：</label>
                                <p>{{ orderDetail.consignor_phone || '--' }}</p>
                            </div>
                        </div>
                    </dd>
                </dl>
                <dt v-if="refundOrderList.length>0">关联未发退款单</dt>
                <c-table v-model="refundOrderList" height="auto" :paging="false" border v-if="refundOrderList.length>0">
                    <c-table-column
                            label="状态"
                            name="state"
                            width="85"
                    >
                        <template v-slot="{data}">
                            <span style="color:#182eff"
                                  v-if="data.state==1">{{ refundOrderStateName[data.state] }}</span>
                            <span style="color:darkgreen"
                                  v-if="data.state==2">{{ refundOrderStateName[data.state] }}</span>
                            <span style="color:gray" v-if="data.state==3">{{ refundOrderStateName[data.state] }}</span>
                            <span style="color:gray" v-if="data.state==4">{{ refundOrderStateName[data.state] }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="退款单号"
                            name="refund_number"
                            width="130"
                    ></c-table-column>

                    <c-table-column
                            label="退款类型"
                            name="refund_type"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.refund_type==1"
                                  style="color:#888888">{{ refundTypeName[data.refund_type] }}</span>
                            <span v-if="data.refund_type==2"
                                  style="color:#ff00ff">{{ refundTypeName[data.refund_type] }}</span>
                            <span v-if="data.refund_type==3"
                                  style="color:#000000">{{ refundTypeName[data.refund_type] }}</span>
                        </template>
                    </c-table-column>
                    <c-table-column
                            label="商品数量"
                            name="product_count"
                            width="80"
                    ></c-table-column>

                    <c-table-column
                            label="商品退款"
                            name="product_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.product_money&&data.product_money>0">￥{{ data.product_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="运费退款"
                            name="logistics_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.logistics_money&&data.logistics_money>0">￥{{ data.logistics_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="服务费退款"
                            name="other_fee"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.other_fee&&data.other_fee>0">￥{{ data.other_fee.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="退款总额"
                            name="refund_total_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.refund_total_money&&data.refund_total_money>0">￥{{ data.refund_total_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请时间"
                            name="create_date"
                            width="150"
                    ></c-table-column>

                    <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                    >
                        <template v-slot="{data}">
                            <c-table-button
                                    @click="navigateTo({path: `/refund_detail/${data.refund_number}`, query: {refundType: data.refund_type}})">
                                查看
                            </c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
                <dt v-if="returnOrderList.length>0">关联已发退货单</dt>
                <c-table v-if="returnOrderList.length>0" v-model="returnOrderList" height="auto" :paging="false" border>
                    <c-table-column
                            label="售后类型"
                            name="return_type"
                            width="90"
                    >
                        <template v-slot="{data}">
                            <span style="color:black" v-if="data.return_type==1">退货退款</span>
                            <span style="color:red" v-if="data.return_type==2">仅退款</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="状态"
                            name="return_state"
                            width="90"
                    >
                        <template v-slot="{data}">
                            <span style="color:#182eff"
                                  v-if="data.return_state==1">{{ returnOrderStateName[data.return_state] }}</span>
                            <span style="color:dodgerblue"
                                  v-if="data.return_state==2">{{ returnOrderStateName[data.return_state] }}</span>
                            <span style="color:dodgerblue"
                                  v-if="data.return_state==3">{{ returnOrderStateName[data.return_state] }}</span>
                            <span style="color:darkgreen"
                                  v-if="data.return_state==5">{{ returnOrderStateName[data.return_state] }}</span>
                            <span style="color:#999999"
                                  v-if="data.return_state==6">{{ returnOrderStateName[data.return_state] }}</span>
                            <span style="color:#999999"
                                  v-if="data.return_state==8">{{ returnOrderStateName[data.return_state] }}</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="退货单号"
                            name="return_number"
                            width="130"
                    ></c-table-column>

                    <c-table-column
                            label="商品数量"
                            name="product_count"
                            width="80"
                    ></c-table-column>

                    <c-table-column
                            label="商品退款"
                            name="product_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.product_money&&data.product_money>0">￥{{ data.product_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="运费退款"
                            name="logistics_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.logistics_money&&data.logistics_money>0">￥{{ data.logistics_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="扣款金额"
                            name="debit_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.debit_money&&data.debit_money>0">￥{{ data.debit_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="实退金额"
                            name="return_total_money"
                    >
                        <template v-slot="{data}">
                            <span style="color:blue"
                                  v-if="data.return_total_money&&data.return_total_money>0">￥{{ data.return_total_money.toFixed(2) }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

<!--                    <c-table-column
                            label="收货状态"
                            name="receiving_state"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.return_type == 1 && (data.return_state == 3 || data.return_state == 5)">
                                <span v-if="data.receiving_state==0"><span style="color:#182eff">待收货</span></span>
                                <span v-if="data.receiving_state==1"><span style="color:darkgreen">已收货</span></span>
                            </span>
                            <span v-else>&#45;&#45;</span>
                        </template>
                    </c-table-column>-->

                    <c-table-column
                            label="寄回物流"
                            name="return_logistics_company"
                            width="150"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.return_logistics_company">
                                {{ data.return_logistics_company }}
                            </span>
                            <span v-if="data.return_logistics_number">
                                 （{{ data.return_logistics_number }}）
                            </span>

                        </template>
                    </c-table-column>

                    <c-table-column
                            label="申请时间"
                            name="create_date"
                            width="150"
                    ></c-table-column>

                    <c-table-column
                            label="审核时间"
                            name="audit_date"
                            width="150"
                    >
                        <template v-slot="{data}">
                            <span v-if="data.audit_date">{{ data.audit_date }}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="打款到账时间"
                            name="remitter_date"
                            width="150"
                    >
                    </c-table-column>

                    <c-table-column
                            type="button"
                            fixed="right"
                            label="操作"
                            width="80"
                    >
                        <template v-slot="{data}">
                            <c-table-button power="m_order_return"
                                            @click="navigateTo(`/return_detail/${data.return_number}`)">查看
                            </c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
                <div style="height:20px;"></div>
            </div>
        </module>
    </page>
</template>

<script>
import productInfo from '@/components/public/product_info.vue'
import {mapState} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    name: 'sub_order_detail',

    components: {
        productInfo
    },

    props: {
        orderNumber: String
    },

    data() {
        return {
            orderDetail: '',
            subOrderDetail: '',
            productList: [],
            giftProductList: [],
            reducedList: [],
            cusTomList: [],
            cusTomInfo: '',
            invoiceInfo: '',
            invoiceDate: '',
            realityMoney: 0,
            sendList: [],
            editList: [],
            logisticsCompany: [],
            sendNum: {},
            orderRemark: '',
            remarkList: [],
            rejectReason: '',
            cancel_reason: '',
            order_remark: '',
            pack_info: [],
            new_logistics_money: 0,
            old_money: 0,
            invoice_file_type: '',//开票文件类型
            invoice_file: '',//发票文件
            invoiceFileType: [{
                name: '附件',
                value: 1
            }, {
                name: '链接',
                value: 2
            }],
            text_msg: '',
            reducedTypeName: {
                0: '代理卡礼包',
                1: '优惠券',
                2: '限时折扣活动优惠',
                3: '代理等级折扣优惠',
                4: '砍价活动优惠',
                5: '抽奖奖品优惠',
                6: '积分抵扣',
                7: '秒杀活动优惠',
                8: '预售活动优惠',
                9: '拼团活动优惠',
                10: '特殊价格优惠',
                11: '新人活动',
                99: '订单调价'
            },
            express_list: [],//物流轨迹
            crtExpress: null,
            refundOrderList: [],
            returnOrderList: [],
            refundOrderStateName: {
                1: '待审核',
                2: '审核通过',
                3: '已驳回',
                4: '已撤销'
            },
            refundTypeName: {
                1: '整单取消',
                2: '未发退款',
                3: '定金退款'
            },
            returnOrderStateName: {
                1: '待审核',
                2: '待会员退货',
                3: '待财务打款',
                5: '退款成功',
                6: '已驳回',
                8: '已撤销'
            },
            operationModeName: {
                1: '平台自营',
                2: '商家自营',
                3: '采购供货'
            },
            orderTypeName: {
                1: '普通',
                2: '积分',
                3: '购买代理卡',
                4: '砍价',
                5: '预定(全款)',
                6: '预定(定金)',
                7: '定制',
                8: '拼团',
                9: '云仓提货',
                10: '送礼',
                11: '抽奖'
            },
            carryTypeName: {
                1: '平台承担',
                2: '商家承担',
                3: '平台/商家共同承担'
            },
            reducedDetailList: [],
            reducedDetailTitle: '优惠明细'
        }
    },

    computed: {
        ...mapState(['systemConfig']),
        ...mapGetters({
            auth: 'power'
        }),

        checkState() {
          return {
                '-1':  '审核驳回',
                '0':  '待支付',
                '1':  '待审核',
                '2':  '已审核',
                '6':  '关闭'
            }[this.subOrderDetail.state];
        },

        orderState() {
            var msg = "";
            if (this.subOrderDetail.state == 0) {
                msg = "当前代理订单下单人尚未完成支付";
            } else if (this.subOrderDetail.state == -1) {
                msg = "当前代理订单，被接单代理审核驳回";
            } else if(this.subOrderDetail.state == 1) {
              msg = "当前代理订单，待接单代理进行审核";
            } else if(this.subOrderDetail.state == 2) {
              if (this.subOrderDetail.agency_user_id == -2){
                msg = "当前代理订单，已流转到平台，待平台进行订单处理";
              }else {
                msg = "当前代理订单，待接单代理已完成审核，将流转到下一个代理等级";
              }
            }else if (this.subOrderDetail.state == 6) {
                msg = "主订单已关闭";
            }
            return msg;
        },

        orderStateWord() {
            var msg = "";
            if (this.orderDetail.refunding_count > 0) {
                msg = "订单存在【未发退款】申请，请先处理完成后再进行其他操作";
            } else if (this.orderDetail.returning_count > 0) {
                msg = "订单存在【已发退货】申请，请先处理完成后再进行其他操作";
            } else {
                if (this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2) {
                    msg = "等待买家支付尾款";
                } else {
                    if (this.orderDetail.order_classify == 1) {
                        var sendTip = '买家已付款，请尽快发货';
                        if (this.orderDetail.order_type == 8) {//拼团
                            if (this.orderDetail.group_achieve == 1) {//已经成团
                                sendTip = '拼团活动已成团，请尽快发货';
                            } else {
                                sendTip = '拼团活动尚未成团，待成团后发货';
                            }
                        }
                        msg = {
                            1: this.orderDetail.payment_type == '转账支付' ? '当前订单使用转账支付，请及时审核' : '请在 ' + this.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
                            // 1:  '请尽快通知客户完成付款（1、客户自行付款，2、销售内勤使用授信挂账审批通过，3、销售内勤执行审批不通过）',
                            2: sendTip,
                            3: (this.orderDetail.deliver_state == '全部发货' ? '如客户未确认收货，订单将于' + this.orderDetail.last_confirm_date + '自动确认收货' : ''),
                            5: '完结时间：' + this.orderDetail.confirm_date,
                            6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name : '') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）' : '')
                        }[this.orderDetail.order_state];
                    } else {
                        var sendTip = '买家已付款，请尽快发货';
                        if (this.orderDetail.order_type == 8) {//拼团
                            if (this.orderDetail.group_achieve == 1) {//已经成团
                                sendTip = '拼团活动已成团，请尽发放卡券';
                            } else {
                                sendTip = '拼团活动尚未成团，待成团后发放卡券';
                            }
                        }
                        msg = {
                            1: this.orderDetail.payment_type == '转账支付' ? '当前订单使用转账支付，请及时审核' : '请在 ' + this.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
                            // 1:  '请尽快通知客户完成付款（1、客户自行付款，2、销售内勤使用授信挂账审批通过，3、销售内勤执行审批不通过）',
                            2: sendTip,
                            3: (this.orderDetail.deliver_state == '全部发货' ? '待买家使用卡券' : ''),
                            5: '完结时间：' + this.orderDetail.confirm_date,
                            6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name : '') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）' : '')
                        }[this.orderDetail.order_state];
                    }
                }
            }
            return msg;
        },

        paymentState() {
            return {
                1: '待付款',
                2: '待付尾款',
                3: '已付款'
            }[this.orderDetail.payment_state];
        },

        paymentTotal() {
            if (this.orderDetail.order_type == 7) {
                return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money || 0).toFixed(2) : (this.orderDetail.product_money + this.cusTomInfo.product_price_money + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
            } else {
                return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money || 0).toFixed(2) : (this.orderDetail.product_money + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
            }
        },

        newProductMoney() {
            var total_product_money = 0;
            this.editList.forEach(item => {
                total_product_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;
            });
            return total_product_money;
        },

        invoiceAddress() {
            if (!this.invoiceInfo) return '';
            return (this.invoiceInfo.address_province_name || '') + (this.invoiceInfo.address_city_name || '') + (this.invoiceInfo.address_county_name || '') + (this.invoiceInfo.address_details || '');
        }
    },

    watch: {
        orderNumber() {
            this.getOrderDetail();
        }
    },

    mounted() {
        this.getOrderDetail();
    },

    methods: {
        //获取订单详情数据
        getOrderDetail() {
            this.request({
                url: '/sub/order/detail',
                data: {
                    sub_order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                    this.orderDetail = data.base_info;
                    this.subOrderDetail = data.sub_order_info;
                    this.order_remark = this.orderDetail.order_remark;
                    this.productList = data.product_sku_info;
                    this.giftProductList = data.gift_product_list;
                    this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money || 0).toFixed(2) : (this.orderDetail.product_money + (this.cusTomInfo.product_price_money || 0) + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
                }
            });
        },
        //订单调价弹框输入等信息录入
        orderEditPriceHandle(stop) {
            if (!stop) {
                this.request({
                    url: '/order/undelivered/product/list',
                    data: {
                        order_number: this.orderNumber
                    },
                    loading: true,
                    success: data => {
                        this.editList = data;
                        this.new_logistics_money = this.orderDetail.logistics_money || '0.00';
                        this.$refs.orderEditPrice.open();
                    }
                });

            } else {
                stop();

                var flag = false;
                var new_total_money = 0;
                this.editList.forEach(item => {
                    if (!item.product_unit_price) {
                        this.$message({
                            text: '请输入调价后单价'
                        });
                        flag = true;
                        return;
                    } else if (parseFloat(item.product_unit_price) <= 0) {
                        this.$message({
                            text: '调价后的单价不能小于等于0'
                        });
                        flag = true;
                        return;
                    } else {
                        new_total_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;
                    }
                });

                if (!this.new_logistics_money) {
                    this.$message({
                        text: '请输入运费'
                    });
                    flag = true;
                    return;
                } else if (parseFloat(this.new_logistics_money) < 0) {
                    this.$message({
                        text: '运费不能小于0'
                    });
                    flag = true;
                    return;
                }

                if (flag) {
                    return;
                }
                new_total_money = new_total_money + (this.cusTomInfo.product_price_money || 0) + parseFloat(this.new_logistics_money || 0);

                if (new_total_money <= 0) {
                    this.$message({
                        text: '调价后的应付总额不能为0元'
                    });
                }

                this.$confirm({
                    text: `确定要对当前订单执行调价操作吗？<br>(原应付金额:￥${this.old_money}，调价后应付金额:<span style="color: #f00">￥${parseFloat(new_total_money).toFixed(2)}</span>)`,
                    resolve: () => {
                        this.orderEditPriceVerifyHandle();
                        this.$refs.orderEditPrice.close();
                        this.$bus.$emit('order.update', {});
                    }
                });
            }
        },
        //执行订单调价请求
        orderEditPriceVerifyHandle() {
            this.request({
                url: '/order/editPrice',
                data: Object.assign({
                    order_number: this.orderNumber,
                    logistics_money: this.new_logistics_money,
                    product_skus: Array.from(this.editList, item => {
                        return {
                            product_sku: item.product_sku,
                            product_unit_price: parseFloat(item.product_unit_price) || 0
                        }
                    })
                }),
                loading: true,
                success: () => {
                    this.$refs.orderEditPrice.close();
                    this.$message({
                        text: '调价执行成功'
                    });
                    this.getOrderDetail();
                }
            });
        },
        //查看物流轨迹
        showLogistics() {
            this.request({
                url: '/order/express',
                data: {
                    order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                    this.express_list = data || [];
                    this.crtExpress = data[0];
                    //展示物流轨迹信息
                    this.$refs.logistics.open();
                }
            });
        },
        //修改买家留言响应方法
        orderRemarkHandle(stop) {
            if (!stop) {
                this.orderRemark = '';
                this.$refs.orderRemark.open();
            } else {
                stop();

                if (!this.orderRemark.trim()) {
                    this.$message({
                        text: '请填写备注'
                    });
                    return;
                }

                this.request({
                    url: '/order/add_customer_service_remark',
                    data: {
                        order_number_arr: [this.orderNumber],
                        customer_service_remark: this.orderRemark.trim()
                    },
                    loading: true,
                    success: () => {
                        this.$refs.orderRemark.close();
                        this.$message({
                            text: '备注成功'
                        });
                    }
                });
            }
        },
        //显示客服备注
        showRemarkList() {
            this.request({
                url: '/order/query_customer_service_remark_list',
                data: {
                    order_number: this.orderNumber
                },
                loading: true,
                success: data => {
                    this.remarkList = data;
                    this.$refs.remarkList.open();
                }
            });
        },
        //审核订单
        checkHandle(type, confirm) {
            var order_number_list = [];
            order_number_list.push(this.orderNumber);
            if (type == 'pass') {
                this.$confirm({
                    text: '确定要审核通过该订单吗？',
                    resolve: () => {
                        this.request({
                            url: '/order/check',
                            data: {
                                order_number_list: order_number_list,
                                check_state: 2,
                                push_u8: 2
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '订单审核成功'
                                });
                                this.getOrderDetail();
                                this.$bus.$emit('order.update', {});
                            }
                        });
                    }
                });
            } else if (confirm) {
                this.request({
                    url: '/order/check',
                    data: {
                        order_number_list: order_number_list,
                        check_state: 3,
                        push_u8: 0,
                        reject_reason: this.rejectReason.trim()
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '订单审核驳回执行成功'
                        });
                        this.getOrderDetail();
                        this.$bus.$emit('order.update', {});
                    }
                });
            } else {
                this.rejectHandle();
            }
        },
        //审核（提交数据）
        rejectHandle(stop) {
            if (!stop) {
                this.rejectReason = '';
                this.$refs.rejectReason.open();
            } else {
                stop();

                if (!this.rejectReason.trim()) {
                    this.$message({
                        text: '请填写审核驳回原因'
                    });
                    return;
                }

                this.checkHandle('reject', true);
                this.$refs.rejectReason.close();
                this.$bus.$emit('order.update', {});
            }
        },
        //关闭订单（弹窗）
        closeHandle(stop) {
            if (!stop) {
                this.cancel_reason = '';
                this.$refs.closeDia.open();
            } else {
                stop();
                if (!this.cancel_reason.trim()) {
                    this.$message({
                        text: '请填写关闭订单原因'
                    });
                    return;
                }
                this.closeSubmitForm();
                this.$refs.closeDia.close();
                this.$bus.$emit('order.update', {});

            }
        },
        //关闭订单（提交数据）
        closeSubmitForm() {
            this.request({
                url: '/order/cancel',
                data: {
                    order_number: this.orderNumber,
                    cancel_reason: this.cancel_reason.trim()
                },
                loading: true,
                success: () => {
                    this.$message({
                        text: '申请取消订单成功'
                    });
                    this.getOrderDetail();
                    this.$bus.$emit('order.update', {});
                }
            });
        },
        //修改买家留言
        reMarkHandle(stop) {
            if (!stop) {
                this.order_remark = this.orderDetail.order_remark;
                this.$refs.reMarkDia.open();
            } else {
                stop();
                this.request({
                    url: '/order/update_remark',
                    data: {
                        order_number: this.orderNumber,
                        order_remark: this.order_remark.trim()
                    },
                    loading: true,
                    success: () => {
                        this.$refs.reMarkDia.close();
                        this.$message({
                            text: '修改买家留言成功'
                        });
                        this.getOrderDetail();
                    }
                });
            }
        },
        onInvoiceFinish() {
            this.order_ids = [this.orderDetail.id];
            this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
            this.realityMoney = parseFloat(this.orderDetail.payment_money || 0).toFixed(2);
            this.$refs.invoiceConf.open();
            this.text_msg = `确定要对订单【<font style="font-size:15px;color:red;">${this.orderDetail.order_number}</font>】执行开票完成操作吗？`;
        },
        submitInvoiceFinish(stop) {
            stop();
            if (!this.invoiceDate) {
                this.$message({
                    text: '请选择开票时间'
                });
                return;
            }
            if (!this.realityMoney) {
                this.$message({
                    text: '请输入实收金额'
                });
                return;
            }
            if (!this.invoice_file_type) {
                this.$message({
                    text: '请选择开票凭证'
                });
                return;
            }
            if (!this.invoice_file) {
                if (this.invoice_file_type == 1) {
                    this.$message({
                        text: '请上传附件'
                    });
                    return;
                }
                if (this.invoice_file_type == 2) {
                    this.$message({
                        text: '请输入链接'
                    });
                    return;
                }
            } else if (this.invoice_file_type == 2) {
                if (this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0) {
                    this.$message({
                        text: '请输入以http://或https://开头的完整链接'
                    });
                    return;
                }
            }
            this.request({
                url: '/order/invoice_finish',
                data: {
                    order_ids: this.order_ids,
                    invoice_date: this.invoiceDate,
                    reality_money: this.realityMoney,
                    is_bath: 0,
                    invoice_file_type: this.invoice_file_type,
                    invoice_file: this.invoice_file
                },
                loading: true,
                success: data => {
                    this.$message({
                        icon: 'success',
                        text: '执行开票完成操作成功'
                    });
                    this.getOrderDetail();
                    this.$refs.invoiceConf.close();
                }
            });
        },
        //展示优惠明细数据
        reducedDetail(reduced_id, title) {
            this.request({
                url: '/order/reduced/detail',
                data: {
                    order_number: this.orderDetail.order_number,
                    reduced_id: reduced_id
                },
                loading: true,
                success: data => {
                    this.reducedDetailList = data;
                    this.reducedDetailTitle = (title || '') + '-优惠明细';
                    this.$refs.reducedDetailDialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/theme'

.order {
    &-state {
        height: 120px;
        padding: 0 34px;
        font-size: 13px;
        color: #fff;
        background: #005CD9;
        background-image: url('~@/assets/image/order_detail_state_bg.png');
        background-size: 100% auto;
        background-position: left bottom;
        background-repeat: no-repeat;

        h1 {
            font-size: 24px;
        }
    }

    &-info {
        width: 500px;
        padding: 30px 30px;

        .tag {
            border-radius: 2px;
            padding: 0 5px;
            margin-left: 6px;
            line-height: 18px;
            color: #fff;
        }

        dt {
            border-left: 3px solid #000;
            padding-left: 5px;
            margin-bottom: 26px;
            line-height: 18px;
            font-size: 16px;
            font-weight: bold;
        }

        &-item {
            padding: 9px 0;
            line-height: 20px;
            font-size: 13px;

            label {
                min-width: 5em;
                color: #666;
                text-align: right;
            }

            p {
                a {
                    color: #005CD9;
                }
            }
        }
    }

    &-detail {
        padding: 30px 30px 40px;

        dt {
            border-left: 3px solid #000;
            padding-left: 5px;
            margin-top: 25px;
            margin-bottom: 10px;
            line-height: 18px;
            font-size: 16px;
            font-weight: bold;
        }
    }

    &-total {
        height: 45px;
        padding: 0 16px;
        font-size: 13px;
        color: #000;
        background: #FAFAFA;

        span {
        theme-color(main);
        }

        b {
            font-size: 16px;
        }
    }

    &-remark {
        padding: 20px;

        textarea {
            box-sizing: border-box;
            width: 100%;
            height: 200px;
            border: none;
            padding: 10px 14px;
            line-height: 20px;
            background: #FAFAFA;
            resize: none;
        }
    }
}

.logistics {
    &-order {
        padding: 14px 18px;

        li {
            border: 1px solid #ddd;
            padding: 0 26px;
            line-height: 42px;
            font-size: 14px;
            color: #666;
            cursor: pointer;

            &:nth-child(n+2) {
                margin-left: 20px;
            }

            &:hover {
                background: #F0F3FC;
            }

            &.z-crt {
                border-color: #005CD9;
                color: #005CD9;
                background: #F0F3FC;
            }
        }
    }

    &-list {
        height: 434px;
        padding: 20px;
        overflow: auto;
        background: #FAFAFA;

        li {
            padding: 10px 0;
            line-height: 24px;
            font-size: 13px;
            color: #333;

            label {
                margin-right: 16px;
                color: #666;
            }
        }
    }
}

.invoice-info {
    max-width: 1000px;
    padding: 30px 0;

    dt {
        border-left: 3px solid #000;
        padding-left: 5px;
        margin-bottom: 26px;
        line-height: 18px;
        font-size: 16px;
        font-weight: bold;
    }

    dd > div:nth-child(1) {
        margin-right 50px;
    }

    &-item {
        padding: 9px 0;
        line-height: 20px;
        font-size: 13px;

        label {
            min-width: 7em;
            color: #666;
            text-align: right;
        }

        p {
            a {
                color: #005CD9;
            }
        }
    }
}

.invoice {
    font-size: 14px;
    color: #000;

    p {
        color: #666;
        height: 30px;
    }
}
</style>